module.exports = __webpack_public_path__ + "img/regist-method-msds.bcee2824.svg";